module.exports = __webpack_public_path__ + "static/media/cycle.88fc43af.svg";